import fetcher from '../API';

export const RENEME_PRODUCT_FULFILLED = 'RENEME_PRODUCT_FULFILLED';
export const renameProduct = (productId, newName, callBack) => {
  const request = fetcher.post(`api/v1/products/${productId}`,newName)
  .then(callBack);
  return {
    type: RENEME_PRODUCT_FULFILLED,
    payload:request
  };
}
